export default class DtoTankSecurity {
    constructor(obj) {
        this.idStation = obj.idStation
        this.equipment = obj.equipment
        this.presence = obj.presence
        this.lastControleDate = obj.lastControleDate
        this.equipmentStateCode = obj.equipmentStateCode
        this.comment = obj.comment
    }
}